import React, { useEffect, useState } from 'react';
import Select from "react-select";
import { getSelectList } from '../../../config/utils';
import { useSelector } from 'react-redux';
import { fetchCompanyFilters, getFilterSellers } from '../../../store/actions/rateCard';
import { getAllCarrierServices, getAllCarrierServicesList, getAllSellersList } from "../../../store/actions";
import _ from 'lodash';
import DatePickerComponent from '../../common/DatePickerComponent';
import { getAllLedgerStatus, getAllLedgerTransactionMode, GetAllLedgerTransactionType } from '../../../store/actions/accounts.action';
import { getAllTaskPriority, getAllTaskStatus, getAllTaskType } from '../../../store/actions/picker.action';
import { requestShipmentStatus } from '../../../constant';
import PropTypes from "prop-types";

/* istanbul ignore next */
const ProductListingFilter = (props) => {
    const { showFilter, handleReset, fetchProductList, dispatch, filterData, setfilterData, sellerList, setSellerList, allSellers, setAllSellers, handleDateFieldChange, type } = props;
    const [companyList, setCompanyList] = useState([]);
    const [transactionModeList, setTransactionModeList] = useState([]);
    const [transactionList, setTransactionList] = useState([]);
    const [statusList, setStatusList] = useState([]);
    const { filterCompanies, filterAllSellers } = useSelector((state) => state.RateCardReducer);
    const { transactionsModeList, transactionTypeList, ledgerStatusList } = useSelector((state) => state.accountingReducer);
    const { allTaskStatusList, allTaskPriorityList, allTaskTypeList } = useSelector((state) => state.pickerReducer);
    const carrierServices = useSelector((state) => state.shipment.carrierServices);
    const carriers = useSelector((state) => state.shipment.carriers);
    const [taskStatusList, setTaskStatusList] = useState([]);
    const [taskPriorityIdList, setTaskPriorityList] = useState([]);
    const [taskTypeIdList, setTaskTypeList] = useState([]);
    const [allCarrierServices, setAllCarrierServices] = useState([]);
    const [carrierIdList, setCarrierIdList] = useState([]);

    useEffect(() => {
        if (type === "task") {
            if (allTaskStatusList.length > 0) {
                setTaskStatusList(getSelectList(allTaskStatusList, "id", "statusName"));
            };

            if (allTaskPriorityList?.length > 0) {
                setTaskPriorityList(getSelectList(allTaskPriorityList, "id", "priorityName"));
            }

            if (allTaskTypeList?.length > 0) {
                setTaskTypeList(getSelectList(allTaskTypeList, "id", "typeName"));
            }
        }
    }, [allTaskStatusList, allTaskPriorityList, allTaskTypeList]);

    useEffect(() => {
        if (carriers?.length) {
            setCarrierIdList(getSelectList(carriers, 'id', 'carrierCompanyName'));
        }
    }, [carriers]);

    useEffect(() => {
        if (carrierServices?.length) {
            setAllCarrierServices(getSelectList(carrierServices, 'id', 'serviceName'));
        }
    }, [carrierServices]);

    useEffect(() => {
        let companyList = filterCompanies?.Entity?.listCompanyMasterOrdersEntity || [];
        let sellerList = filterAllSellers?.EntityList || [];
        if (companyList.length) {
            setCompanyList(getSelectList(filterCompanies?.Entity?.listCompanyMasterOrdersEntity, 'Id', 'name'));
        }
        if (sellerList.length) {
            setAllSellers(getSelectList(sellerList, 'id', 'sellerName'));
            setSellerList(getSelectList(sellerList, 'id', 'sellerName'));
        }
    }, [filterCompanies, filterAllSellers]);

    useEffect(() => {
        if (type === "ledger" && transactionTypeList.length === 0) {
            dispatch(GetAllLedgerTransactionType());
        } else if (transactionTypeList.length > 0) {
            setTransactionList(getSelectList(transactionTypeList, "id", "transactionType"));
        }
    }, [type, transactionTypeList]);

    useEffect(() => {
        if (type === "ledger" && transactionsModeList.length === 0) {
            dispatch(getAllLedgerTransactionMode());
        } else if (transactionsModeList.length > 0) {
            setTransactionModeList(getSelectList(transactionsModeList, "id", "transactionMode"));
        }
    }, [type, transactionsModeList]);

    useEffect(() => {
        if (type === "ledger" && ledgerStatusList.length === 0) {
            dispatch(getAllLedgerStatus());
        } else if (ledgerStatusList.length > 0) {
            setStatusList(getSelectList(ledgerStatusList, "id", "statusName"));
        }
    }, [type, ledgerStatusList]);

    const handleMultiSelect = (value, fieldName) => {
        setfilterData({
            ...filterData,
            [fieldName]: value
        });
        if (fieldName === "companyIdList") {
            let companyData = _.map(value, "Id");
            fetchSellers(companyData);
            if (filterData?.sellerIdList?.length) {
                const filteredSellers = filterData.sellerIdList.filter(seller =>
                    companyData.includes(parseInt(seller.companyIds))
                );
                setfilterData({ ...filterData, sellerIdList: filteredSellers, companyIdList: value })
            }
        }
    }

    const fetchSellers = async (companyList) => {
        if (companyList.length === 0) {
            setSellerList(allSellers);
            return;
        }
        let data = {
            companyIds: companyList,
        };
        try {
            let res = await getAllSellersList(data);
            if (res?.data?.Status === 200) {
                let dataList = res?.data?.Entity?.listSellerMasterOrdersEntity.map(
                    (item) => {
                        return {
                            ...item,
                            label: item.sellerAndCompany,
                            value: item.id,
                        };
                    }
                );
                setSellerList(dataList);
            }
        } catch (err) {
            console.log(err);
        }
    };

    useEffect(() => {
        let data = {
            pageIndex: 1,
            pageSize: 10,
            sortColumn: 'name',
            sortOrder: 'ascending'
        };
        let sellerData = {
            "pageIndex": 1,
            "pageSize": 10,
            "sortColumn": "name",
            "sortOrder": "ASCENDING",
            "companyIdList": [0],
            screenType: 2,
        };
        dispatch(fetchCompanyFilters(data));
        dispatch(getFilterSellers(sellerData));
        if (type === "task") {
            if (!allTaskStatusList?.length) {
                dispatch(getAllTaskStatus());
            }
            if (!allTaskPriorityList?.length) {
                dispatch(getAllTaskPriority());
            }
            if (!allTaskTypeList?.length) {
                dispatch(getAllTaskType());
            }
        }
        if (type === "refunds") {
            if (!carrierServices.length) {
                dispatch(getAllCarrierServices({}));
            }
            if (!carrierServices.length) {
                dispatch(getAllCarrierServicesList());
            }
        }
    }, []);

    return (
        <div className={showFilter ? 'filterWrapperGradient filterContainer filterContainerZIndex show historyFilter zIndex2 pt-2' : 'filterContainer historyFilter'}>
            <div className='decorativeElem'></div>
            <div className='row mb-2'>
                <div className='col-lg-3 col-sm-12 mobMb-10'>
                    <div className='row'>
                        <div className='col-12'>
                            <div className='labelHead'>Company</div>
                        </div>
                        <div className='col-12 fontFix'>
                            <Select
                                isMulti
                                closeMenuOnSelect={false}
                                options={companyList}
                                classNamePrefix="list"
                                id='companyIdList'
                                name="companyIdList"
                                value={filterData?.companyIdList}
                                onChange={(value) =>
                                    handleMultiSelect(value, "companyIdList")
                                }
                            />
                        </div>
                    </div>
                </div>
                <div className='col-lg-3 col-sm-12 mobMb-10'>
                    <div className='row'>
                        <div className='col-12'>
                            <div className='labelHead'>Seller</div>
                        </div>
                        <div className='col-12 fontFix'>
                            <Select
                                isMulti
                                closeMenuOnSelect={false}
                                options={sellerList}
                                classNamePrefix="list"
                                id='sellerIdList'
                                name="sellerIdList"
                                value={filterData?.sellerIdList}
                                onChange={(value) =>
                                    handleMultiSelect(value, "sellerIdList")
                                }
                            />
                        </div>
                    </div>
                </div>
                {((type && type === "ledger") || type === "sellerLedger") && (
                    <>
                        <div className='col-lg-3 col-sm-12 mobMb-10'>
                            <div className='row'>
                                <div className='col-12'>
                                    <div className='labelHead'>From:</div>
                                </div>
                                <div className='col-12 fontFix'>
                                    <DatePickerComponent
                                        dateField={filterData.startDate}
                                        handleDateChange={(date) => handleDateFieldChange(date, 'startDate')}
                                        fieldName="startDate"
                                        dateFormat="MM-dd-yyyy"
                                    />
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-3 col-sm-12 mobMb-10 '>
                            <div className='row'>
                                <div className='col-12'>
                                    <div className='labelHead'>To:</div>
                                </div>
                                <div className='col-12 fontFix'>
                                    <DatePickerComponent
                                        dateField={filterData.endDate}
                                        handleDateChange={(date) => handleDateFieldChange(date, 'endDate')}
                                        fieldName="endDate"
                                        dateFormat="MM-dd-yyyy"
                                    />
                                </div>
                            </div>
                        </div>
                    </>
                )}
                {type && type === "ledger" && (
                    <>
                        <div className='col-lg-3 col-sm-12 mobMb-10 mt-4'>
                            <div className='row'>
                                <div className='col-12'>
                                    <div className='labelHead'>Transaction Mode</div>
                                </div>
                                <div className='col-12 fontFix'>
                                    <Select
                                        isMulti
                                        closeMenuOnSelect={false}
                                        options={transactionModeList}
                                        classNamePrefix="list"
                                        id='transactionModeIdList'
                                        name="transactionModeIdList"
                                        value={filterData?.transactionModeIdList}
                                        onChange={(value) =>
                                            handleMultiSelect(value, "transactionModeIdList")
                                        }
                                    />
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-3 col-sm-12 mobMb-10 mt-4'>
                            <div className='row'>
                                <div className='col-12'>
                                    <div className='labelHead'>Transaction Type</div>
                                </div>
                                <div className='col-12 fontFix'>
                                    <Select
                                        isMulti
                                        closeMenuOnSelect={false}
                                        options={transactionList}
                                        classNamePrefix="list"
                                        id='transactionTypeIdList'
                                        name="transactionTypeIdList"
                                        value={filterData?.transactionTypeIdList}
                                        onChange={(value) =>
                                            handleMultiSelect(value, "transactionTypeIdList")
                                        }
                                    />
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-3 col-sm-12 mobMb-10 mt-4'>
                            <div className='row'>
                                <div className='col-12'>
                                    <div className='labelHead'>Status</div>
                                </div>
                                <div className='col-12 fontFix'>
                                    <Select
                                        isMulti
                                        closeMenuOnSelect={false}
                                        options={statusList}
                                        classNamePrefix="list"
                                        id='statusIdList'
                                        name="statusIdList"
                                        value={filterData?.statusIdList}
                                        onChange={(value) =>
                                            handleMultiSelect(value, "statusIdList")
                                        }
                                    />
                                </div>
                            </div>
                        </div>
                    </>
                )}

                {type && type === "task" && (
                    <>
                        <div className='col-lg-3 col-sm-12 mobMb-10'>
                            <div className='row'>
                                <div className='col-12'>
                                    <div className='labelHead'>Status</div>
                                </div>
                                <div className='col-12 fontFix'>
                                    <Select
                                        isMulti
                                        closeMenuOnSelect={false}
                                        options={taskStatusList}
                                        classNamePrefix="list"
                                        id='taskStatusList'
                                        name="taskStatusList"
                                        value={filterData?.taskStatusList}
                                        onChange={(value) =>
                                            handleMultiSelect(value, "taskStatusList")
                                        }
                                    />
                                </div>
                            </div>
                        </div>

                        <div className='col-lg-3 col-sm-12 mobMb-10'>
                            <div className='row mb-2'>
                                <div className='col-12'>
                                    <div className='labelHead'>Priority</div>
                                </div>
                                <div className='col-12 fontFix'>
                                    <Select
                                        isMulti
                                        closeMenuOnSelect={false}
                                        options={taskPriorityIdList}
                                        classNamePrefix="list"
                                        id='taskPriorityIdList'
                                        name="taskPriorityIdList"
                                        value={filterData?.taskPriorityIdList}
                                        onChange={(value) =>
                                            handleMultiSelect(value, "taskPriorityIdList")
                                        }
                                    />
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-3 col-sm-12 mobMb-10'>
                            <div className='row'>
                                <div className='col-12'>
                                    <div className='labelHead'>Type</div>
                                </div>
                                <div className='col-12 fontFix'>
                                    <Select
                                        isMulti
                                        closeMenuOnSelect={false}
                                        options={taskTypeIdList}
                                        classNamePrefix="list"
                                        id='taskTypeIdList'
                                        name="taskTypeIdList"
                                        value={filterData?.taskTypeIdList}
                                        onChange={(value) =>
                                            handleMultiSelect(value, "taskTypeIdList")
                                        }
                                    />
                                </div>
                            </div>
                        </div>
                    </>
                )}

                {type && type === "refunds" && (
                    <>
                        <div className='col-lg-3 col-sm-12 mobMb-10'>
                            <div className='row'>
                                <div className='col-12'>
                                    <div className='labelHead'>Carrier</div>
                                </div>
                                <div className='col-12 fontFix'>
                                    <Select
                                        isMulti
                                        closeMenuOnSelect={false}
                                        options={carrierIdList}
                                        classNamePrefix="list"
                                        name="carrierIdList"
                                        value={filterData?.carrierIdList}
                                        onChange={(value) =>
                                            handleMultiSelect(value, "carrierIdList")
                                        }
                                    />
                                </div>
                            </div>
                        </div>

                        <div className='col-lg-3 col-sm-12 mobMb-10'>
                            <div className='row'>
                                <div className='col-12'>
                                    <div className='labelHead'>Service</div>
                                </div>
                                <div className='col-12 fontFix'>
                                    <Select
                                        isMulti
                                        closeMenuOnSelect={false}
                                        options={allCarrierServices}
                                        classNamePrefix="list"
                                        name="serviceIdList"
                                        value={filterData?.serviceIdList}
                                        onChange={(value) =>
                                            handleMultiSelect(value, "serviceIdList")
                                        }
                                    />
                                </div>
                            </div>
                        </div>

                        <div className='col-lg-3 col-sm-12 mt-2 mobMb-10'>
                            <div className='row'>
                                <div className='col-12'>
                                    <div className='labelHead'>Shipment Status</div>
                                </div>
                                <div className='col-12 fontFix'>
                                    <Select
                                        isMulti
                                        closeMenuOnSelect={false}
                                        options={requestShipmentStatus}
                                        classNamePrefix="list"
                                        name="statusIdList"
                                        value={filterData?.statusIdList}
                                        onChange={(value) =>
                                            handleMultiSelect(value, "statusIdList")
                                        }
                                    />
                                </div>
                            </div>
                        </div>
                    </>
                )}
            </div>
            <div className='alignRightRes mb-3 pr-0'>
                <button
                    className="btn cus-primary-transparent-btn top-btn clearFilterBtn"
                    onClick={(e) => handleReset(e, 'clear')}
                >
                    Clear Filter
                </button>
                <button
                    className="cus-seconday-bg-btn btn filterBtn"
                    onClick={() => fetchProductList(null)}
                >
                    Apply
                </button>
            </div>
        </div>
    );
}

ProductListingFilter.propTypes = {
    showFilter: PropTypes.bool,
    handleReset: PropTypes.func,
    fetchProductList: PropTypes.func,
    dispatch: PropTypes.func,
    filterData: PropTypes.object,
    setfilterData: PropTypes.func,
    sellerList: PropTypes.array,
    setSellerList: PropTypes.func,
    allSellers: PropTypes.array,
    setAllSellers: PropTypes.func,
    handleDateFieldChange: PropTypes.func,
    type: PropTypes.string
}

export default ProductListingFilter;